import { render, staticRenderFns } from "./DeliveryLoading.vue?vue&type=template&id=8f63b9d4&scoped=true"
import script from "./DeliveryLoading.vue?vue&type=script&lang=js"
export * from "./DeliveryLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f63b9d4",
  null
  
)

export default component.exports